import { Config } from '../../config'

export const daiConfig: Config = {
  partner: 'dai',
  catalog: 'partner',
  displayName: 'DAI Scientific',
  accentColor: '#002144',
  host: 'seating.daiscientific.com',
  extraAttributes: {
    easyForm: true,
  },
}
